import { Component, toNative, Vue } from '~/utility/pu-class-decorator'
import AuthMixin from './AuthMixin'

@Component({
  mixins: [AuthMixin],
})
class RequireGuestMixin extends Vue {
  async authMounted() {
    if (this.isLoggedIn) {
      await this.$router.push('/')
    }
  }
}

export default toNative(RequireGuestMixin)
